import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
